import { createFileRoute, Outlet, Navigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Layout } from '@/components/Layout';
import { OnboardingGate } from '@/components/OnboardingGate';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, isAuthenticated, checkAuth, isInitializing } = useAuthStore();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  useEffect(() => {
    // Only call checkAuth if we're still initializing (haven't checked yet)
    if (isInitializing) {
      checkAuth();
    }
  }, [checkAuth, isInitializing]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/" search={{ redirect: pathname }} />;
  }

  // Check if user is a librarian
  if (user.role !== 'librarian') {
    // Logout non-librarian user
    useAuthStore.getState().logout();
    return <Navigate to="/" />;
  }

  return (
    <Layout teacherName={`${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Admin'}>
      <OnboardingGate />
      <Outlet />
    </Layout>
  );
}

